import debounce from "lodash/debounce"

class MobileMenu {
  constructor() {
    this.openButton = document.querySelector(".header #MobileNavToggle")
    this.closeButton = document.querySelector(".mobile-menu .header__mobile-toggle--menu")

    this.keyCodes = {
      tab: 9,
      enter: 13,
      space: 32,
      pageup: 33,
      pagedown: 34,
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      escape: 27,
    }

    this.bindEvents()
  }

  bindEvents() {
    const menuButtons = document.querySelectorAll(".mobile-nav__item button")

    this.openButton.addEventListener(
      "click",
      debounce(() => {
        this.handleMenuOpen()
      }, 150)
    )

    this.closeButton.addEventListener(
      "click",
      debounce(() => {
        this.handleMenuClose()
      }, 150)
    )

    menuButtons.forEach(b => {
      b.addEventListener(
        "click",
        debounce(ev => {
          this.handleSubmenuToggle(ev)
        }, 150)
      )
    })

    window.addEventListener("resize", () => {
      if (window.matchMedia("(min-width: 1200px)").matches) {
        const menu = document.getElementById(this.openButton.getAttribute("aria-controls"))

        if (menu && menu.getAttribute("aria-hidden") === "false") {
          menu.setAttribute("aria-hidden", "true")
          this.toggleMainContentAttributes()
        }
      }
    })
  }

  handleMenuOpen() {
    const menu = document.getElementById(this.openButton.getAttribute("aria-controls"))
    const body = document.querySelector("body")

    if (menu) {
      menu.setAttribute("aria-hidden", "false")
      menu.style.height = `${body.clientHeight}px`

      this.closeButton.setAttribute("aria-expanded", "true")
      this.openButton.setAttribute("aria-expanded", "true")
      this.closeButton.focus()

      this.toggleMainContentAttributes()

      body.style.overflow = "hidden"
      body.classList.add("no-scroll")
    }
  }

  handleMenuClose() {
    const menu = document.getElementById(this.closeButton.getAttribute("aria-controls"))
    const body = document.querySelector("body")

    if (menu) {
      menu.setAttribute("aria-hidden", "true")

      this.closeButton.setAttribute("aria-expanded", "false")
      this.openButton.setAttribute("aria-expanded", "false")
      this.openButton.focus()

      this.toggleMainContentAttributes()

      body.style.overflow = ""
      body.classList.remove("no-scroll")
    }
  }

  handleSubmenuToggle(ev) {
    const button = ev.target
    const submenu = document.getElementById(button.getAttribute("aria-controls"))

    const body = document.querySelector("body")
    const menu = document.getElementById(this.closeButton.getAttribute("aria-controls"))

    this.closeOpenSubmenus(submenu)

    if (submenu.classList.contains("mobile-nav__submenu--open")) {
      this.closeSubmenu(button, submenu)
    } else {
      this.openSubmenu(button, submenu)
    }

    menu.style.height = `${body.clientHeight + submenu.clientHeight}px`
  }

  toggleMainContentAttributes() {
    const main = document.querySelector("main[role='main']")
    const footer = document.querySelector(".footer")

    if (main && footer) {
      if (main.getAttribute("aria-hidden") === "false") {
        main.setAttribute("aria-hidden", "true")
      } else {
        main.setAttribute("aria-hidden", "false")
      }

      if (footer.getAttribute("aria-hidden") === "false") {
        footer.setAttribute("aria-hidden", "true")
      } else {
        footer.setAttribute("aria-hidden", "false")
      }
    }
  }

  closeOpenSubmenus(submenu) {
    const openSubmenus = document.querySelectorAll(".mobile-nav__submenu--open")

    openSubmenus.forEach(o => {
      if (o !== submenu) {
        const btn = o.parentNode.querySelector("button")
        const icon = btn.querySelector("i")

        btn.setAttribute("aria-expanded", "false")
        btn.setAttribute("aria-label", btn.getAttribute("aria-label").replace(/^Close/, "Open"))
        btn.parentNode.classList.remove("active")

        icon.textContent = "expand_more"

        o.classList.remove("mobile-nav__submenu--open")
        o.setAttribute("aria-hidden", "true")
      }
    })
  }

  closeSubmenu(button, submenu) {
    const icon = button.querySelector("i")

    button.setAttribute("aria-expanded", "false")
    button.setAttribute("aria-label", button.getAttribute("aria-label").replace(/^Close/, "Open"))
    button.parentNode.classList.remove("active")

    submenu.setAttribute("aria-hidden", "true")
    submenu.classList.remove("mobile-nav__submenu--open")

    icon.textContent = "expand_more"
  }

  openSubmenu(button, submenu) {
    const icon = button.querySelector("i")

    button.setAttribute("aria-expanded", "true")
    button.setAttribute("aria-label", button.getAttribute("aria-label").replace(/^Open/, "Close"))
    button.parentNode.classList.add("active")

    submenu.setAttribute("aria-hidden", "false")
    submenu.classList.add("mobile-nav__submenu--open")

    icon.textContent = "expand_less"
  }
}

export default function init() {
  if (document.querySelector(".mobile-menu")) {
    new MobileMenu()
  }
}
